import React from 'react';
import { Menu, MenuItem } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';

export default function ToolMenu({ anchorEl, onClose, onSettings, onDelete }) {
    const { t } = useTranslation();

    return (
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
            <MenuItem onClick={() => { onClose(); onSettings(); }}>
                <SettingsIcon fontSize="small" style={{ marginRight: 8 }} />
                {t("settings")}
            </MenuItem>
            <MenuItem onClick={() => { onClose(); onDelete(); }} sx={{ color: 'error.main' }}>
                <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
                {t("delete")}
            </MenuItem>
        </Menu>
    );
}
